module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integralMallOrder zdy-groupList commonStyle"
  }, [_c('x-header', [_vm._v("确认订单")]), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin-top": "46px"
    }
  }, [_c('cell', {
    attrs: {
      "title": "商品名称:"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "数量:",
      "value": _vm.num
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "支付方式:",
      "value": "积分支付"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "商品总额:",
      "value": _vm.total + ' 积分'
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "我的积分:",
      "value": _vm.integra + ' 积分'
    }
  })], 1), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.bigtitle.indexOf('大众点评') != -1),
      expression: "this.bigtitle.indexOf('大众点评') !=-1"
    }],
    staticStyle: {
      "color": "red",
      "text-align": "left",
      "padding": "10px 15px"
    }
  }, [_vm._v("大众点评电子券用于大众点评平台内兑换消费，兑换后有效期一个月，为避免遗忘使用，请于需要时进行兑换！")]), _vm._v(" "), _c('x-button', {
    staticClass: "change",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sureClick($event)
      }
    }
  }, [_vm._v("确认支付")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('x-dialog', {
    staticClass: "integralMallOrderdialog",
    model: {
      value: (_vm.showtel),
      callback: function($$v) {
        _vm.showtel = $$v
      },
      expression: "showtel"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('h3', [_vm._v("请确认兑换号码")]), _vm._v(" "), _c('group', {
    staticClass: "vux-1px-l vux-1px-r",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "手机号码",
      "placeholder-align": "right",
      "text-align": "right",
      "keyboard": "number",
      "placeholder": "请输入手机号码"
    },
    on: {
      "on-blur": _vm.telchange
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.phoneNoIcon),
      expression: "phoneNoIcon"
    }],
    staticClass: "warnIcon",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.IconClick('必填哦！')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "integralMallOrdergroupBtn"
  }, [_c('x-button', {
    staticClass: "folatLeft",
    attrs: {
      "mini": "",
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.telsure($event)
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('x-button', {
    staticClass: "folatright",
    attrs: {
      "mini": "",
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showtel = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)]), _vm._v(" "), _c('x-dialog', {
    staticClass: "integralMallOrderdialog",
    model: {
      value: (_vm.showToast),
      callback: function($$v) {
        _vm.showToast = $$v
      },
      expression: "showToast"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('h3', [_vm._v("温馨提示")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red",
      "text-align": "left"
    }
  }, [_vm._v("大众点评电子券用于大众点评平台内兑换消费，兑换后有效期一个月，为避免遗忘使用，请于需要时进行兑换！")]), _vm._v(" "), _c('div', {
    staticClass: "integralMallOrdergroupBtn"
  }, [_c('x-button', {
    staticClass: "folatLeft",
    attrs: {
      "mini": "",
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("确认兑换")]), _vm._v(" "), _c('x-button', {
    staticClass: "folatright",
    attrs: {
      "mini": "",
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.showToast = false
      }
    }
  }, [_vm._v("取消")])], 1)])])], 1), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "width": "250px",
      "time": 1000,
      "is-show-mask": "",
      "text": _vm.toastTxt,
      "position": "middle"
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ea2a88b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/integralMallProject/integralMallOrder.vue
// module id = bal3
// module chunks = 7